import { useCallback } from 'react';

/**
 * Hook that returns a function to scroll an element into view.
 * Useful for mobile when the keyboard opens and fields go out of view.
 */
export function useScrollIntoView() {
  const scrollIntoView = useCallback((element: HTMLElement | null) => {
    if (!element) return;
    
    // Use setTimeout to allow the keyboard to open first on mobile
    setTimeout(() => {
      element.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
        inline: 'nearest',
      });
    }, 300);
  }, []);

  return scrollIntoView;
}

